// JavaScript Document
// 動きのきっかけとなるアニメーションの名前を定義
function fadeAnime(){

  $('.fade_Up_Trigger').each(function(){ //fadeUpTriggerというクラス名が
    var elemPos = $(this).offset().top-50;//要素より、50px上の
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight){
    $(this).addClass('fadeUp');// 画面内に入ったらfadeUpというクラス名を追記
    }else{
    $(this).removeClass('fadeUp');// 画面外に出たらfadeUpというクラス名を外す
    }
    });

  $('.fade_Left_Trigger').each(function(){ //fadeUpTriggerというクラス名が
    var elemPos = $(this).offset().top-50;//要素より、50px上の
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight){
    $(this).addClass('fadeLeft');// 画面内に入ったらfadeUpというクラス名を追記
    }else{
    $(this).removeClass('fadeLeft');// 画面外に出たらfadeUpというクラス名を外す
    }
    });
    
  $('.fade_Right_Trigger').each(function(){ //fadeUpTriggerというクラス名が
    var elemPos = $(this).offset().top-50;//要素より、50px上の
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight){
    $(this).addClass('fadeRight');// 画面内に入ったらfadeUpというクラス名を追記
    }else{
    $(this).removeClass('fadeRight');// 画面外に出たらfadeUpというクラス名を外す
    }
    });
 
   $('.fade_Down_Trigger').each(function(){ //fadeUpTriggerというクラス名が
    var elemPos = $(this).offset().top-50;//要素より、50px上の
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight){
    $(this).addClass('fadeDown');// 画面内に入ったらfadeUpというクラス名を追記
    }else{
    $(this).removeClass('fadeDown');// 画面外に出たらfadeUpというクラス名を外す
    }
    });
 
    
}

// 画面をスクロールをしたら動かしたい場合の記述
  $(window).scroll(function (){
    fadeAnime();/* アニメーション用の関数を呼ぶ*/
  });// ここまで画面をスクロールをしたら動かしたい場合の記述
